import css from 'styled-jsx/css';

const styles = css`.centered-on-decimal {
    display: flex;
    width: 100%;
    justify-content: center;
    -webkit-user-select: text;
            user-select: text;
}

.whole-number {
    min-width: 50%;
    text-align: right;
}

.decimal-number {
    flex: 1;
    text-align: left;
}
`;

export default styles;